import moment from 'moment';
import 'moment/locale/vi';

moment.locale('vi');

export function parseShortTime(time: string, format = 'MM.YYYY') {
  return moment(new Date(time)).format(format);
}

export const convertNumberToTimeString = (time: number) =>
  ('' + time).padStart(2, '0');

export const parseTime = (startDate: string, endDate: string) => {
  return (
    <p className="text-[12px] text-[#979797]">
      {startDate ? new Date(startDate).getFullYear() + ' - ' : ''}
      {endDate ? new Date(endDate).getFullYear() : 'Nay'}
    </p>
  );
};

export const parseTimeWithMonth = (startDate: string, endDate: string) => {
  const _startDate = new Date(startDate);
  const _endDate = new Date(endDate);

  const startMonth =
    _startDate.getMonth() + 1 > 9
      ? _startDate.getMonth() + 1
      : '0' + (_startDate.getMonth() + 1);

  const endMonth =
    _endDate.getMonth() + 1 > 9
      ? _endDate.getMonth() + 1
      : '0' + (_endDate.getMonth() + 1);

  return (
    <p className="text-[12px] text-[#979797]">
      {startDate ? startMonth + '.' + _startDate.getFullYear() + ' - ' : ''}
      {/* we must parse the + 1 here, because JS count the months from 0, and date from 1 */}
      {/* {endDate && endMonth + '.' + _endDate.getFullYear()} */}
      {endDate ? endMonth + '.' + _endDate.getFullYear() : 'Nay'}
    </p>
  );
};

export const formatTimeYYYYMMDD = (
  inputDateString: string,
  format: moment.MomentFormatSpecification = 'DD-MM-YYYY'
): string => {
  if (!inputDateString) return '';

  const formattedDate = moment(inputDateString, format).toISOString();

  return formattedDate;
};

export const convertHHMMSSToHM = (time: string): string => {
  return moment(time, 'hh:mm:ss').format('H [giờ] m [phút]');
};

export const convertHHMMSSToMMSS = (time: string): string => {
  const parsedTime = moment.duration(time);

  const totalMinutes = Math.floor(parsedTime.asMinutes());
  const remainingSeconds = parsedTime.seconds();

  const formattedTime = `${totalMinutes}:${remainingSeconds
    .toString()
    .padStart(2, '0')}`;
  return formattedTime;
};

export const formatTimeDDMMYYYY = (
  inputDateString: string,
  format: moment.MomentFormatSpecification = 'YYYY-MM-DD'
): string => {
  if (!inputDateString) return '';

  const formattedDate = moment(inputDateString, format).format('DD/MM/YYYY');

  return formattedDate;
};
